import { HeadlineProps } from "@/types/ui-kit/ui";
import React from "react";
import { FollowButton } from "@/components/ui-kit/Buttons/FollowButton";
import Link from "next/link";

export const RelatedSectionHeadline: React.FC<HeadlineProps> = ({ title, displayFollowButton, ctaBasicLink }) => {
  return (
    <header className="py-2">
      <div className="flex items-center justify-between border-b-2 border-orange">
        {ctaBasicLink ? (
          <Link href={ctaBasicLink} className="hover:underline">
            <h2 className="py-2 font-condensed text-lg font-light uppercase dark:text-white">{title}</h2>
          </Link>
        ) : (
          <h2 className="py-2 font-condensed text-lg font-light uppercase dark:text-white">{title}</h2>
        )}
        {displayFollowButton && <FollowButton onClick={() => console.log("clicked")} />}
      </div>
    </header>
  );
};
